var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6186 150.879L33.5932 150.888L33.5683 150.899C33.5254 150.917 33.4873 150.931 33.4537 150.942C33.4278 150.899 33.3989 150.845 33.3653 150.778C31.6021 147.073 29.7241 143.25 27.824 139.382C24.0287 131.656 20.1452 123.751 16.9123 116.247C18.9459 115.84 21.4592 115.762 24.1686 115.878C27.1783 116.008 30.3468 116.371 33.2364 116.734C37.5249 126.35 41.9704 135.928 46.6099 145.393C42.3929 147.429 38.0627 149.246 33.6186 150.879Z",
  fill: "white",
  stroke: "#0CCFCF",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.3645 144.136L36.5296 150.444",
  stroke: "#0CCFCF",
  strokeMiterlimit: 10
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.0591 126.069C37.385 130.189 39.3097 134.137 41.7049 137.785C42.9453 137.27 44.1857 136.669 45.3405 135.982C43.7152 131.991 41.876 128.043 39.7802 124.267C38.4543 124.567 37.2139 125.211 36.0591 126.069Z",
  fill: "#0CCFCF"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.8002 104.626L3.80026 104.626C5.65698 108.228 8.39493 111.402 11.8522 113.258C15.7256 115.322 20.2572 115.671 24.7676 115.671H24.771C33.2596 115.7 41.7393 114.838 50.2631 113.971C54.1415 113.577 58.0291 113.182 61.9308 112.869C74.3476 111.874 86.8002 111.733 99.0807 115.281C103.819 116.633 108.374 118.549 112.743 120.85L112.745 120.851C113.151 121.065 113.502 121.237 113.828 121.335C114.003 121.388 114.145 121.411 114.261 121.413C114.378 121.224 114.537 120.935 114.73 120.541C115.132 119.723 115.657 118.498 116.221 116.88C117.348 113.647 118.621 108.869 119.374 102.673C120.88 90.2871 120.307 72.2252 112.318 49.4997C104.31 26.7204 95.7514 14.3673 88.8776 7.84335C85.442 4.58255 82.4348 2.78476 80.1326 1.86044C78.9806 1.39789 78.0121 1.15681 77.2594 1.05703C76.4873 0.954671 76.0021 1.00866 75.7849 1.07461L75.7807 1.07588C75.2272 1.24128 74.6397 1.84673 73.9774 3.28567C73.4015 4.53699 72.8757 6.16875 72.2472 8.11887C72.1744 8.34491 72.1001 8.57522 72.0243 8.80971C70.5844 13.262 68.6387 18.9665 64.6537 24.1575L64.6531 24.1584C51.8217 40.8342 30.1331 59.0094 16.2538 69.3246M3.8002 104.626L15.6573 68.522M3.8002 104.626C-0.483748 96.319 0.234339 86.0029 5.46697 78.9467M3.8002 104.626L4.66505 78.3493M16.2538 69.3246L15.6573 68.522M16.2538 69.3246C16.254 69.3245 16.2542 69.3243 16.2544 69.3242L15.6573 68.522M16.2538 69.3246C16.049 69.4771 15.8444 69.6291 15.6402 69.7809C11.8427 72.6031 8.16756 75.3344 5.46697 78.9467M15.6573 68.522C15.4415 68.6827 15.2254 68.8432 15.0093 69.0037C11.242 71.8027 7.45616 74.6154 4.66505 78.3493M5.46697 78.9467C5.46739 78.9461 5.46781 78.9455 5.46823 78.945L4.66505 78.3493M5.46697 78.9467C5.46665 78.9471 5.46633 78.9475 5.466 78.948L4.66505 78.3493",
  fill: "white",
  stroke: "#0CCFCF",
  strokeWidth: 2
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M116.341 119.332C119.72 111.135 126.307 86.2453 113.261 49.125C100.815 13.7213 86.9142 3.16454 79.8142 0.675552C78.0178 10.9748 74.8527 38.7828 86.016 67.6637C92.945 85.6445 99.9595 98.4757 105.862 107.23C109.84 113.152 113.176 117.358 116.341 119.332Z",
  fill: "#D7DFE8"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M111.636 87.6185C101.414 89.5925 90.2076 73.6287 85.075 65.1747C85.3744 65.9901 85.6738 66.8054 85.9732 67.6208C92.9022 85.6016 99.9167 98.4328 105.819 107.187C109.84 113.152 113.176 117.358 116.341 119.332C118.608 113.796 122.329 100.707 120.532 81.396C118.308 84.5287 115.4 86.889 111.636 87.6185Z",
  fill: "#0CCFCF"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M106.974 108.603C108.77 111.221 110.695 113.796 112.748 116.414",
  stroke: "#0CCFCF",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M79.0871 4.70943C79.0871 4.70943 70.2762 53.2876 104.878 105.471",
  stroke: "#0CCFCF",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M2.31626 84.9859L2.32651 84.9564C2.33218 84.9429 2.33827 84.9278 2.34442 84.9113C2.35622 84.8798 2.37095 84.8364 2.38385 84.7831C2.66294 83.9544 3.02072 83.1186 3.42147 82.3144L3.42155 82.3145L3.42756 82.302C3.99909 81.1142 4.69194 79.9701 5.46214 78.9533L5.46216 78.9533L5.46597 78.9482C8.08205 75.4485 11.6452 72.7788 15.2945 70.0446C15.6137 69.8055 15.9336 69.5658 16.2535 69.325C16.8964 68.8536 17.5684 68.3532 18.253 67.8321C18.6968 76.2343 19.973 84.7119 22.7518 92.834C25.5536 101.066 30.0602 108.951 36.2554 115.245C32.4057 115.521 28.5792 115.671 24.7247 115.671C20.214 115.671 15.682 115.322 11.8084 113.257C8.35223 111.402 5.61498 108.229 3.75846 104.628C1.99212 101.166 1.08573 97.3685 1.00279 93.566C0.961841 90.6211 1.37594 87.6932 2.31626 84.9859Z",
  stroke: "#0CCFCF",
  strokeWidth: 2
});
var _ref11 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M2.56921 92.6394C2.56921 92.6394 2.78307 80.1945 19.3783 70.3243",
  stroke: "#0CCFCF",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M1.45715 91.7812C1.45715 91.7812 10.9952 98.9048 10.9952 111.993",
  stroke: "#0CCFCF",
  strokeMiterlimit: 10
}));
var _ref12 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M58.6424 106.672C70.1051 105.556 84.8612 105.771 97.7354 111.221",
  stroke: "#0CCFCF",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M39.3953 110.148C39.3953 110.148 45.4688 108.346 54.4508 107.144",
  stroke: "#0CCFCF",
  strokeMiterlimit: 10
}));
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M41 150C45 158.833 50.6 178.6 41 187",
  stroke: "#192E53",
  strokeWidth: 3,
  strokeDasharray: "5 5"
});
function SvgCampaign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 189,
    viewBox: "0 0 122 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.b9cb34612e1a4c84505c90c07c770cb9.svg";
export { ForwardRef as ReactComponent };